export default __webpack_public_path__ + "static/media/Delete.eb05007e.mp3";